import { createContext } from 'react';

const processContext = createContext();

export default processContext;
